import React from 'react';
import PropTypes from 'prop-types';

const ZoomTo = ({ id, zoomToHeadstone }) => (
  <button
    onClick={zoomToHeadstone}
    id={id}
    className="zoomToButton"
  >
    <svg
      width={25}
      height={25}
    >
      <g transform={`translate(${25 / 2} ${25 / 2})`}>
        <line
          x1={30 / -3}
          x2={30 / 3}
          y1={0}
          y2={0}
          stroke="#262626"
          strokeWidth={30 / 15}
        />

        <line
          x1={0}
          x2={0}
          y1={30 / -3}
          y2={30 / 3}
          stroke="#262626"
          strokeWidth={30 / 15}
        />

        <circle
          cx={0}
          cy={0}
          r={30 / 4.5}
          fill="#f5f5f5"
          fillOpacity={1}
          stroke="#262626"
          strokeWidth={30 / 15}
        />

        <circle
          cx={0}
          cy={0}
          r={30 / 8}
          fill="#262626"
        />
      </g>
    </svg>
  </button>
);

export default ZoomTo;

ZoomTo.propTypes = {
  id: PropTypes.number.isRequired,
  zoomToHeadstone: PropTypes.func,
};

ZoomTo.defaultProps = {
  onClick: () => false,
};



// WEBPACK FOOTER //
// ./src/components/ZoomToButton.jsx